// eslint-disable-next-line
// @ts-nocheck
import SvgManager from '../core/SvgManager';
import getResource from '../core/resources';
import { favorites as favoriteMethods } from 'store';

const icons = {
	navContents: '../images/NavContentsOn.svg'
};

SvgManager.enqueue(Object.values(icons));

export const contentTabId = 'content-tab';

const contentTab = {
	id: contentTabId,
	image: icons.navContents,
	cssClass: 'aras-navigation-panel-tabs__content-tab'
};

function getItemTypeIds(dataMap) {
	const itemTypeIds = new Set();
	dataMap.forEach(({ formId, itemTypeId, startPage }) => {
		if (!itemTypeId || formId || startPage) {
			return;
		}
		itemTypeIds.add(itemTypeId);
	});
	return itemTypeIds;
}

export function updateLockedStatus(favorites, dataMap) {
	const itemTypeIds = getItemTypeIds(dataMap);
	favorites.forEach((item, id) => {
		if (!item.itemTypeId) {
			return;
		}

		const locked = !itemTypeIds.has(item.itemTypeId);
		if (locked !== item.locked) {
			favorites.set(id, { ...item, locked });
		}
	});
}

export function getSidebarData(favorites, dataMap) {
	const sidebarData = new Map();
	sidebarData.set(contentTab.id, {
		...contentTab,
		tooltip_template: getResource('common.contents')
	});

	const itemTypeIds = getItemTypeIds(dataMap);
	favorites.forEach((item) => {
		const additionalData = { ...item.additional_data };
		const itemTypeId = additionalData.id;
		delete additionalData.id;
		const favoriteItem = {
			...item,
			...additionalData,
			itemTypeId,
			locked: !itemTypeIds.has(itemTypeId),
			parentTab: contentTabId,
			tooltip_template: additionalData.label
		};
		delete favoriteItem.label;
		sidebarData.set(favoriteItem.id, favoriteItem);
	});

	return sidebarData;
}

export function getFavoriteItemTypes(favorites) {
	const filtered = favoriteMethods.filterFavorites(favorites, 'ItemType');
	return filtered.reduce(
		(acc, favorite) => acc.set(favorite.id, favorite),
		new Map()
	);
}
